import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NaoEncontrada: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-24 max-w-3xl text-center">
      <Helmet>
        <title>Página não encontrada | eFortiPsi</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <h1 className="text-3xl font-bold text-[#2a3c5c] mb-4">Página não encontrada</h1>
      <p className="text-gray-700 mb-8">O endereço que você abriu não existe ou mudou de lugar.</p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/" className="rounded-lg bg-[#2a3c5c] px-6 py-3 text-white font-semibold hover:bg-[#1f2f4c]">
          Ir para o início
        </Link>
        <Link to="/blog" className="rounded-lg border border-[#2a3c5c] px-6 py-3 text-[#2a3c5c] font-semibold hover:bg-[#edf2fb]">
          Ver o blog
        </Link>
      </div>
    </div>
  );
};

export default NaoEncontrada;
